import React from 'react';
import { Typography, Tooltip } from 'antd';

const { Text } = Typography;

export default function PriceTag({ price, retailPrice, currency = 'USD', size = 'default' }) {
  const symbol = currency === 'USD' ? '$' : currency;
  const displayPrice = (price || 0) / 100;
  const displayRetail = retailPrice ? retailPrice / 100 : null;
  const discountPercent = displayRetail
    ? Math.round((1 - displayPrice / displayRetail) * 100)
    : null;

  const fontSize = size === 'large' ? 28 : size === 'small' ? 14 : 20;

  return (
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, flexWrap: 'wrap' }}>
      <Tooltip title={`${symbol}${displayPrice.toFixed(2)}${displayRetail ? ` (was ${symbol}${displayRetail.toFixed(2)})` : ''}`}>
        <Text style={{
          fontSize,
          fontWeight: 700,
          fontFamily: 'var(--df-font-display, Sora, sans-serif)',
          color: 'var(--df-primary, #0B3A5C)',
          lineHeight: 1.15,
          letterSpacing: '-0.02em',
        }}>
          {symbol}{displayPrice.toFixed(2)}
        </Text>
      </Tooltip>
      {displayRetail && (
        <Text delete style={{ fontSize: fontSize * 0.72, color: 'var(--df-text-muted, #8494A7)' }}>
          {symbol}{displayRetail.toFixed(2)}
        </Text>
      )}
      {discountPercent > 0 && (
        <Text style={{
          fontSize: Math.max(11, fontSize * 0.62),
          fontWeight: 700,
          fontFamily: 'var(--df-font-display, Sora, sans-serif)',
          color: 'var(--df-success, #0F7B5A)',
          background: 'rgba(15, 123, 90, 0.1)',
          padding: '2px 8px',
          borderRadius: 6,
          lineHeight: 1.4,
        }}>
          −{discountPercent}%
        </Text>
      )}
    </div>
  );
}
